import React, {Component} from 'react';
import ReactDataGrid from 'react-data-grid';
import './DataGrid.css';
import * as _ from 'lodash';
import {CSVLink} from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { inspect } from 'util';


var delayTimer; 

class StatsDataGrid extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleFilterChange = this.handleFilterChange.bind(this);    
    this.state = {rows: this.props.data};

  }
  
  componentDidMount() {
    this.refs.grid.onToggleFilter();
  }
 
  componentDidUpdate(prevProps) {
    let prevData = inspect(prevProps.data);
    let newData = inspect(this.props.data);
    //JSON.stringify was breaking due to a circular reference inspect remove circular references
    if(newData !== prevData) {
      this.applyRowFilters(this.props.rowFilter);
    }  
  
    if(JSON.stringify(this.props.statsColumns) !== JSON.stringify(prevProps.statsColumns)) {
      this.refs.grid.setState({ canFilter: false });
      setTimeout(() => this.refs.grid.setState({ canFilter: true }), 1);
      this.clearFilters();
    }


  }

  rowGetter = (i) => {
    return this.state.rows[i]; 
  };

  handleFilterChange = (filter) => {

    let newFilters = Object.assign({}, this.props.rowFilter);

    /* Assign filters */

    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
  
    clearTimeout(delayTimer);
    delayTimer = setTimeout(() => {
      this.applyStatsRowFilters(newFilters);
    }, 30);
  };

  applyStatsRowFilters = (newFilters) => {
    var filteredRows = this.props.data;
    if(!_.isEmpty(newFilters))
    {
      filteredRows = this.props.data.filter(row => {
        return Object.keys(newFilters).every(key => {
          if(row[key]){
            if(typeof row[key] === "string")
            {
              return row[key].toUpperCase().includes(newFilters[key].filterTerm.toUpperCase())
            } 
            else {
              return row[key].toString().toUpperCase().includes(newFilters[key].filterTerm.toUpperCase())
            }
          } else {
            return false;
          }
        })
      })
    }
    
    this.props.setStatsFilters(newFilters);
    this.setState({ rows: filteredRows });
  }

  clearFilters = () => {
    this.setState({rows: this.props.data }); 
  };

  downloadGrid = () => {
    let csvColumns = [];
    for(let statsColumn of this.props.statsColumns){
      csvColumns.push(statsColumn.key);
    }
    
    return this.state.rows.map(row => {
      return _.pick(row, csvColumns);
    });
  };

  render() {
    return  (
      <div>
          <div className="row">
            <div className="col-12 mb-2">
              <CSVLink  data={this.downloadGrid()} filename="stats.csv" >
                <FontAwesomeIcon icon={faDownload} size="lg" color="#666666" pull="right"/>
              </CSVLink>
            </div>
          </div>        
          <ReactDataGrid
            enableCellSelect={true}
            columns={this.props.statsColumns}
            rowGetter={this.rowGetter}
            rowsCount={this.state.rows ? this.state.rows.length : 0}
            minHeight={window.innerHeight - 200}
            onGridRowsUpdated={this.props.handleGridRowsUpdated} 
            onAddFilter={this.handleFilterChange}
            onClearFilters={this.clearFilters}
            ref="grid"
          />
      </div>);

        
  }
}

   

export default StatsDataGrid;



// WEBPACK FOOTER //
// ./src/components/DataGrid/StatsDataGrid.js